<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit VIP Privilege
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                prepend-inner-icon="mdi-format-title"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-file-input
                v-model="iconFile"
                outlined
                label="Icon Image"
                prepend-inner-icon="mdi-image"
                accept="image/*"
                @change="handleIconUpload"
                :clearable="true"
                show-size
              >
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                rows="4"
              ></v-textarea>
            </v-col>
            <v-col sm="12" v-if="previewIcon || form.icon_path">
              <v-card outlined>
                <v-card-title class="subtitle-2">Icon Preview</v-card-title>
                <v-card-text class="text-center">
                  <v-avatar size="80">
                    <img
                      :src="previewIcon || form.icon_path"
                      alt="Icon preview"
                    />
                  </v-avatar>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !isFormValid"
            @click="save"
          >
            Update VIP Privilege
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "VipPrivilegeIdPage",
  data() {
    return {
      form: {
        title: "",
        icon_path: "",
        description: "",
        is_active: 1,
      },
      old_json: null,
      iconFile: null,
      previewIcon: null,
      isLoading: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    isFormValid() {
      return this.form.title && this.form.title.trim() !== "";
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.privilegeId;
      try {
        const response = await axios.get(`/vip_privileges/${encryptedId}`);
        this.form = response.data.data;
        this.old_json = JSON.parse(JSON.stringify(response.data.data));

        if (this.form.icon_path) {
          this.previewIcon = this.mediaUrl + this.form.icon_path; // ✅ full preview URL
        }

        // Convert is_active to number if it's boolean
        if (typeof this.form.is_active === "boolean") {
          this.form.is_active = this.form.is_active ? 1 : 0;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        this.$toast.error("Failed to load privilege data");
      }
      this.isLoading = false;
    },

    handleIconUpload(file) {
      if (file) {
        this.iconFile = file; // ✅ assign file to iconFile

        // Preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewIcon = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.iconFile = null;
        this.previewIcon = null;
      }
    },

    async uploadIcon(privilegeId) {
      if (!this.iconFile) return;

      const formData = new FormData();
      formData.append("id", privilegeId);
      formData.append("icon_path", this.iconFile); // ✅ binary file

      try {
        const response = await axios.post(
          "/upload_vipprivilege_image", // ✅ corrected endpoint (with slash)
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        this.form.icon_path = response.data.path;
      } catch (error) {
        console.error("Error uploading icon:", error);
        this.$toast.error("Failed to upload icon");
      }
    },

    async save() {
      if (!this.isFormValid) {
        this.$toast.error("Please fill in all required fields");
        return;
      }

      try {
        this.isLoading = true;
        const response = await axios.patch(
          `/vip_privileges/${this.$route.params.privilegeId}`,
          this.form
        );
        console.log("Update response:", response);
        // ✅ Now upload the icon if a new one was selected
        if (this.iconFile) {
          await this.uploadIcon(this.form.id);
        }

        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
        this.$router.push("/vip-privileges");
      } catch (e) {
        console.error("Error saving:", e);
        this.$toast.error("Failed to update VIP Privilege");
        this.isLoading = false;
      }
    },

    async saveUserTimestamp(oldData, newData) {
      try {
        let form = {
          from_path: `/vip_privileges/${this.form.id}`,
          from_name: "VipPrivilegeIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(oldData),
          new_json: JSON.stringify(newData),
        };
        await axios.post(`/user_timestamps`, form);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
